import { IDatePickerStrings } from "office-ui-fabric-react";

// Call during render with t from useTranslation("admin") so the strings follow the current language
export const getDatePickerStrings = (t: any): IDatePickerStrings => ({
  months: [
    t("datePicker.months.0") as string,
    t("datePicker.months.1") as string,
    t("datePicker.months.2") as string,
    t("datePicker.months.3") as string,
    t("datePicker.months.4") as string,
    t("datePicker.months.5") as string,
    t("datePicker.months.6") as string,
    t("datePicker.months.7") as string,
    t("datePicker.months.8") as string,
    t("datePicker.months.9") as string,
    t("datePicker.months.10") as string,
    t("datePicker.months.11") as string,
  ],
  shortMonths: [
    t("datePicker.shortMonths.0") as string,
    t("datePicker.shortMonths.1") as string,
    t("datePicker.shortMonths.2") as string,
    t("datePicker.shortMonths.3") as string,
    t("datePicker.shortMonths.4") as string,
    t("datePicker.shortMonths.5") as string,
    t("datePicker.shortMonths.6") as string,
    t("datePicker.shortMonths.7") as string,
    t("datePicker.shortMonths.8") as string,
    t("datePicker.shortMonths.9") as string,
    t("datePicker.shortMonths.10") as string,
    t("datePicker.shortMonths.11") as string,
  ],
  days: [
    t("datePicker.days.0") as string,
    t("datePicker.days.1") as string,
    t("datePicker.days.2") as string,
    t("datePicker.days.3") as string,
    t("datePicker.days.4") as string,
    t("datePicker.days.5") as string,
    t("datePicker.days.6") as string,
  ],
  shortDays: [
    t("datePicker.shortDays.0") as string,
    t("datePicker.shortDays.1") as string,
    t("datePicker.shortDays.2") as string,
    t("datePicker.shortDays.3") as string,
    t("datePicker.shortDays.4") as string,
    t("datePicker.shortDays.5") as string,
    t("datePicker.shortDays.6") as string,
  ],
  goToToday: t("datePicker.goToToday") as string,
  prevMonthAriaLabel: t("datePicker.prevMonthAriaLabel") as string,
  nextMonthAriaLabel: t("datePicker.nextMonthAriaLabel") as string,
  prevYearAriaLabel: t("datePicker.prevYearAriaLabel") as string,
  nextYearAriaLabel: t("datePicker.nextYearAriaLabel") as string,
  closeButtonAriaLabel: t("datePicker.closeButtonAriaLabel") as string,
});
